import React, { createContext } from 'react';
import { initNewWindowHandlers, useCreateNewWindowHandlersForContext } from '../hooks/useCreateNewWindowHandlersForContext';
export const NewWindowHandlersContext = /*#__PURE__*/createContext(initNewWindowHandlers);
export const NewWindowHandlersContextProvider = _ref => {
  let {
    children
  } = _ref;
  const newWindowHandlers = useCreateNewWindowHandlersForContext();
  return /*#__PURE__*/React.createElement(NewWindowHandlersContext.Provider, {
    value: newWindowHandlers
  }, children);
};
export const useNewWindowHandlers = () => React.useContext(NewWindowHandlersContext);
//# sourceMappingURL=NewWindowHandlersContext.js.map